//==============================
// Waypoints
//==============================

$('.animation-item').waypoint(function(direction) {
  var thisElement = $(this.element);
  if (direction === "down") {
    thisElement.addClass('animate');
  }
}, {
  offset: '80%',
  triggerOnce: true
});

$('.animation-parent').waypoint(function(direction) {
  var thisElement = $(this.element);
  if (direction === "down") {
    thisElement.addClass('animate');
  }
}, {
  offset: '80%',
  triggerOnce: true
});
